import React, { useState } from "react";
import UpTastingLogo from "../../../../assets/images/hcb_logo_light.png";
import styled from "@emotion/styled";
import Button from "../../../shared/Button";
import Background1 from "../../../../assets/images/buser1.jpg";

const EndComponent = ({ config, canStart, start }) => {
    const Wrapper = {
        height: "100%",
        width: "100%",
        display: "flex",
        position: "relative",
        background: "white",
        justifyContent: "center",
        flexDirection: "column"
    };

    const Content = {
        width: "50%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
    };

    const LogoStyle = styled.img`
        max-width: 10vw;
        max-height: 10vh;
        margin: 4vh auto;
    `;

    const Text = styled.div`
        margin: 4vh auto;
        color: black;
        font-size: 3vh;
    `;

    const Title = {
        width: "calc(100% - 4vh)",
        borderRadius: "1vh",
        backgroundColor: "#3C3C3B",
        color: "white",
        fontSize: "4.5vh",
        padding: "2vh",
        textAlign: "center",
        fontWeight: "bold",
        position: "relative"
    }

    return (
        <div style={Wrapper}>
            <img src={config.background || Background1} style={{position: "fixed",height: "100vh",width: "100vw", opacity: 0.5}}></img>
            <div style={Content}>
                {console.log(config)}
                <div style={Title}>{config.getTranslatedText(config.survey.endMessage)}</div>
            </div>
        </div>
    );
};

export default EndComponent;
